import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import LandingPage from "./pages/LandingPage";
import OffsetPage from "./pages/OffsetPage";
import ImpactPage from "./pages/ImpactPage";
import BusinessPage from "./pages/BusinessPage";

function App() {
  const merchantCode = 'TON_OF_FUN_AU';

  useEffect(() => {
  }, []);

  return (
    <>

      <Switch>
        <Route
          exact
          path={`/business`}
          key="app-TON_OF_FUN_AU-business"
        >
          <BusinessPage merchantCode={merchantCode} />
        </Route>
        <Route
          path={`/`}
          key="app-TON_OF_FUN_AU-landing"
        >
          <LandingPage merchantCode={merchantCode} />
        </Route>
      </Switch>

    </>
  );
}

export default App;
